export default {
	urlApis(state){ return state.urlApis; },
	langTutor(state){ return state.langTutor; },
	accessApp(state){ return state.access; },
	get_asideStorage(state){ return state.asideStorage;},
	selectedItem(state){ return state.selectedItem;},
}
